'use client'

import { useContext, useState } from 'react'

import { toast } from 'react-toastify'
import { cn, Spinner } from '@nextui-org/react'

import useUploadImage from '@/hooks/useUploadImage'
import { useCommentMutation } from '@/redux/api/feed/feed.w3api'
import { FeedContext } from '@/components/shared/ContentFeed/CardSS'
import { useAppSelector } from '@/hooks'
import { PostCommentType } from '@/redux/api/feed/feed.type'

import { PostContext, TextareaPost, TextareaPostProvider } from '../TextareaPostProvider'

export const scrollToTop = () => {
  document.querySelector('#scrollToTop')?.scrollIntoView({ behavior: 'smooth', block: 'start' })
}

export const ImplementCommentProvider = ({ postId }: { postId: string }) => {
  const [commentPost, { isLoading }] = useCommentMutation()
  const [commentLoading, setCommentLoading] = useState(false) // Add loading state
  const { loading } = useUploadImage()
  const { handleUploadImage } = useUploadImage()
  const { images, textPost, setImages, setMetadata, setTextPost } = useContext(PostContext) || {}
  const { setDatas } = useContext(FeedContext) || {}
  const spaceActive = useAppSelector((state) => state.root.settings.spaceActive)

  const handleComment = async () => {
    if (textPost === '' && images.length === 0) {
      return
    }

    setCommentLoading(true)
    try {
      let listIMG: string[] = []
      if (images.length) {
        listIMG = await handleUploadImage(images)
      }

      const comment = {
        content: textPost,
        postId: postId,
        commentParentId: null,
        imageUrl: listIMG?.[0],
      } as PostCommentType

      if (spaceActive) {
        comment.spaceId = spaceActive
      }

      await commentPost(comment)

      scrollToTop()
      setDatas?.((prev) =>
        prev.map((it) => (it.postId === postId ? { ...it, commentCount: (it.commentCount || 0) + 1 } : it)),
      )
      setTextPost('')
      setImages([])
      setMetadata(null)
    } catch (error) {
      console.log('error', error)

      toast.error('Create comment failed, please try again!')
    } finally {
      setCommentLoading(false)
    }
  }

  return (
    <button
      onClick={handleComment}
      disabled={commentLoading || loading}
      className={cn(
        textPost || images.length > 0 ? 'ss-btn' : 'ss-btn-disable',
        'flex items-center gap-1 rounded-2xl  px-4 py-2 text-xs font-medium',
      )}
    >
      {(loading || isLoading) && <Spinner size="sm" />} Sent
    </button>
  )
}

const CommentTextarea = ({ postId }: { postId: string }) => {
  return (
    <TextareaPostProvider>
      <TextareaPost type="comment">
        <ImplementCommentProvider postId={postId} />
      </TextareaPost>
    </TextareaPostProvider>
  )
}

export default CommentTextarea
